[
  {
    "id": "001_venetian_masquerade_1_headwear_a_tier_1",
    "item_id": "001_venetian_masquerade_1_headwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "001_venetian_masquerade_1_headwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "001_venetian_masquerade/01_color_A/01_tier_1/01_headwear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_1_headwear_a_tier_2",
    "item_id": "001_venetian_masquerade_1_headwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "001_venetian_masquerade_1_headwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "001_venetian_masquerade/01_color_A/02_tier_2/01_headwear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_1_headwear_a_tier_3",
    "item_id": "001_venetian_masquerade_1_headwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "001_venetian_masquerade/01_color_A/03_tier_3/01_headwear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_2_eyewear_a_tier_1",
    "item_id": "001_venetian_masquerade_2_eyewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "001_venetian_masquerade_2_eyewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "001_venetian_masquerade/01_color_A/01_tier_1/02_eyewear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_2_eyewear_a_tier_2",
    "item_id": "001_venetian_masquerade_2_eyewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "001_venetian_masquerade_2_eyewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "001_venetian_masquerade/01_color_A/02_tier_2/02_eyewear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_2_eyewear_a_tier_3",
    "item_id": "001_venetian_masquerade_2_eyewear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "001_venetian_masquerade/01_color_A/03_tier_3/02_eyewear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_3_facewear_a_tier_1",
    "item_id": "001_venetian_masquerade_3_facewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "001_venetian_masquerade_3_facewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "001_venetian_masquerade/01_color_A/01_tier_1/03_facewear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_3_facewear_a_tier_2",
    "item_id": "001_venetian_masquerade_3_facewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "001_venetian_masquerade_3_facewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "001_venetian_masquerade/01_color_A/02_tier_2/03_facewear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_3_facewear_a_tier_3",
    "item_id": "001_venetian_masquerade_3_facewear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "001_venetian_masquerade/01_color_A/03_tier_3/03_facewear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_4_neckwear_a_tier_1",
    "item_id": "001_venetian_masquerade_4_neckwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "001_venetian_masquerade_4_neckwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "001_venetian_masquerade/01_color_A/01_tier_1/04_neckwear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_4_neckwear_a_tier_2",
    "item_id": "001_venetian_masquerade_4_neckwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "001_venetian_masquerade_4_neckwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "001_venetian_masquerade/01_color_A/02_tier_2/04_neckwear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_4_neckwear_a_tier_3",
    "item_id": "001_venetian_masquerade_4_neckwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "001_venetian_masquerade/01_color_A/03_tier_3/04_neckwear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_5_backwear_a_tier_1",
    "item_id": "001_venetian_masquerade_5_backwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "001_venetian_masquerade_5_backwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "001_venetian_masquerade/01_color_A/01_tier_1/05_backwear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_5_backwear_a_tier_2",
    "item_id": "001_venetian_masquerade_5_backwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "001_venetian_masquerade_5_backwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "001_venetian_masquerade/01_color_A/02_tier_2/05_backwear.png",
    "animated": false
  },
  {
    "id": "001_venetian_masquerade_5_backwear_a_tier_3",
    "item_id": "001_venetian_masquerade_5_backwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "001_venetian_masquerade/01_color_A/03_tier_3/05_backwear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_1_headwear_a_tier_1",
    "item_id": "002_disco_night_fever_1_headwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "002_disco_night_fever_1_headwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "002_disco_night_fever/01_color_A/01_tier_1/01_headwear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_1_headwear_a_tier_2",
    "item_id": "002_disco_night_fever_1_headwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "002_disco_night_fever_1_headwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "002_disco_night_fever/01_color_A/02_tier_2/01_headwear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_1_headwear_a_tier_3",
    "item_id": "002_disco_night_fever_1_headwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "002_disco_night_fever/01_color_A/03_tier_3/01_headwear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_2_eyewear_a_tier_1",
    "item_id": "002_disco_night_fever_2_eyewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "002_disco_night_fever_2_eyewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "002_disco_night_fever/01_color_A/01_tier_1/02_eyewear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_2_eyewear_a_tier_2",
    "item_id": "002_disco_night_fever_2_eyewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "002_disco_night_fever_2_eyewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "002_disco_night_fever/01_color_A/02_tier_2/02_eyewear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_2_eyewear_a_tier_3",
    "item_id": "002_disco_night_fever_2_eyewear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "002_disco_night_fever/01_color_A/03_tier_3/02_eyewear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_3_facewear_a_tier_1",
    "item_id": "002_disco_night_fever_3_facewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "002_disco_night_fever_3_facewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "002_disco_night_fever/01_color_A/01_tier_1/03_facewear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_3_facewear_a_tier_2",
    "item_id": "002_disco_night_fever_3_facewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "002_disco_night_fever_3_facewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "002_disco_night_fever/01_color_A/02_tier_2/03_facewear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_3_facewear_a_tier_3",
    "item_id": "002_disco_night_fever_3_facewear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "002_disco_night_fever/01_color_A/03_tier_3/03_facewear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_4_neckwear_a_tier_1",
    "item_id": "002_disco_night_fever_4_neckwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "002_disco_night_fever_4_neckwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "002_disco_night_fever/01_color_A/01_tier_1/04_neckwear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_4_neckwear_a_tier_2",
    "item_id": "002_disco_night_fever_4_neckwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "002_disco_night_fever_4_neckwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "002_disco_night_fever/01_color_A/02_tier_2/04_neckwear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_4_neckwear_a_tier_3",
    "item_id": "002_disco_night_fever_4_neckwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "002_disco_night_fever/01_color_A/03_tier_3/04_neckwear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_5_backwear_a_tier_1",
    "item_id": "002_disco_night_fever_5_backwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "002_disco_night_fever_5_backwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "002_disco_night_fever/01_color_A/01_tier_1/05_backwear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_5_backwear_a_tier_2",
    "item_id": "002_disco_night_fever_5_backwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "002_disco_night_fever_5_backwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "002_disco_night_fever/01_color_A/02_tier_2/05_backwear.png",
    "animated": false
  },
  {
    "id": "002_disco_night_fever_5_backwear_a_tier_3",
    "item_id": "002_disco_night_fever_5_backwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "002_disco_night_fever/01_color_A/03_tier_3/05_backwear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_1_headwear_a_tier_1",
    "item_id": "003_sweet_lolita_1_headwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "003_sweet_lolita_1_headwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "003_sweet_lolita/01_color_A/01_tier_1/01_headwear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_1_headwear_a_tier_2",
    "item_id": "003_sweet_lolita_1_headwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "003_sweet_lolita_1_headwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "003_sweet_lolita/01_color_A/02_tier_2/01_headwear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_1_headwear_a_tier_3",
    "item_id": "003_sweet_lolita_1_headwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "003_sweet_lolita/01_color_A/03_tier_3/01_headwear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_2_eyewear_a_tier_1",
    "item_id": "003_sweet_lolita_2_eyewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "003_sweet_lolita_2_eyewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "003_sweet_lolita/01_color_A/01_tier_1/02_eyewear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_2_eyewear_a_tier_2",
    "item_id": "003_sweet_lolita_2_eyewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "003_sweet_lolita_2_eyewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "003_sweet_lolita/01_color_A/02_tier_2/02_eyewear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_2_eyewear_a_tier_3",
    "item_id": "003_sweet_lolita_2_eyewear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "003_sweet_lolita/01_color_A/03_tier_3/02_eyewear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_3_facewear_a_tier_1",
    "item_id": "003_sweet_lolita_3_facewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "003_sweet_lolita_3_facewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "003_sweet_lolita/01_color_A/01_tier_1/03_facewear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_3_facewear_a_tier_2",
    "item_id": "003_sweet_lolita_3_facewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "003_sweet_lolita_3_facewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "003_sweet_lolita/01_color_A/02_tier_2/03_facewear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_3_facewear_a_tier_3",
    "item_id": "003_sweet_lolita_3_facewear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "003_sweet_lolita/01_color_A/03_tier_3/03_facewear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_4_neckwear_a_tier_1",
    "item_id": "003_sweet_lolita_4_neckwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "003_sweet_lolita_4_neckwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "003_sweet_lolita/01_color_A/01_tier_1/04_neckwear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_4_neckwear_a_tier_2",
    "item_id": "003_sweet_lolita_4_neckwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "003_sweet_lolita_4_neckwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "003_sweet_lolita/01_color_A/02_tier_2/04_neckwear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_4_neckwear_a_tier_3",
    "item_id": "003_sweet_lolita_4_neckwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "003_sweet_lolita/01_color_A/03_tier_3/04_neckwear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_5_backwear_a_tier_1",
    "item_id": "003_sweet_lolita_5_backwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "003_sweet_lolita_5_backwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "003_sweet_lolita/01_color_A/01_tier_1/05_backwear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_5_backwear_a_tier_2",
    "item_id": "003_sweet_lolita_5_backwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "003_sweet_lolita_5_backwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "003_sweet_lolita/01_color_A/02_tier_2/05_backwear.png",
    "animated": false
  },
  {
    "id": "003_sweet_lolita_5_backwear_a_tier_3",
    "item_id": "003_sweet_lolita_5_backwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "003_sweet_lolita/01_color_A/03_tier_3/05_backwear.png",
    "animated": false
  },
  {
    "id": "004_oiran_1_headwear_a_tier_1",
    "item_id": "004_oiran_1_headwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "004_oiran_1_headwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "004_oiran/01_color_A/01_tier_1/01_headwear.png",
    "animated": false
  },
  {
    "id": "004_oiran_1_headwear_a_tier_2",
    "item_id": "004_oiran_1_headwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "004_oiran_1_headwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "004_oiran/01_color_A/02_tier_2/01_headwear.png",
    "animated": false
  },
  {
    "id": "004_oiran_1_headwear_a_tier_3",
    "item_id": "004_oiran_1_headwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "004_oiran/01_color_A/03_tier_3/01_headwear.png",
    "animated": false
  },
  {
    "id": "004_oiran_2_eyewear_a_tier_1",
    "item_id": "004_oiran_2_eyewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "004_oiran_2_eyewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "004_oiran/01_color_A/01_tier_1/02_eyewear.png",
    "animated": false
  },
  {
    "id": "004_oiran_2_eyewear_a_tier_2",
    "item_id": "004_oiran_2_eyewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "004_oiran_2_eyewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "004_oiran/01_color_A/02_tier_2/02_eyewear.png",
    "animated": false
  },
  {
    "id": "004_oiran_2_eyewear_a_tier_3",
    "item_id": "004_oiran_2_eyewear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "004_oiran/01_color_A/03_tier_3/02_eyewear.png",
    "animated": false
  },
  {
    "id": "004_oiran_3_facewear_a_tier_1",
    "item_id": "004_oiran_3_facewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "004_oiran_3_facewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "004_oiran/01_color_A/01_tier_1/03_facewear.png",
    "animated": false
  },
  {
    "id": "004_oiran_3_facewear_a_tier_2",
    "item_id": "004_oiran_3_facewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "004_oiran_3_facewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "004_oiran/01_color_A/02_tier_2/03_facewear.png",
    "animated": false
  },
  {
    "id": "004_oiran_3_facewear_a_tier_3",
    "item_id": "004_oiran_3_facewear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "004_oiran/01_color_A/03_tier_3/03_facewear.png",
    "animated": false
  },
  {
    "id": "004_oiran_4_neckwear_a_tier_1",
    "item_id": "004_oiran_4_neckwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "004_oiran_4_neckwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "004_oiran/01_color_A/01_tier_1/04_neckwear.png",
    "animated": false
  },
  {
    "id": "004_oiran_4_neckwear_a_tier_2",
    "item_id": "004_oiran_4_neckwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "004_oiran_4_neckwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "004_oiran/01_color_A/02_tier_2/04_neckwear.png",
    "animated": false
  },
  {
    "id": "004_oiran_4_neckwear_a_tier_3",
    "item_id": "004_oiran_4_neckwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "004_oiran/01_color_A/03_tier_3/04_neckwear.png",
    "animated": false
  },
  {
    "id": "004_oiran_5_backwear_a_tier_1",
    "item_id": "004_oiran_5_backwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "004_oiran_5_backwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "004_oiran/01_color_A/01_tier_1/05_backwear.png",
    "animated": false
  },
  {
    "id": "004_oiran_5_backwear_a_tier_2",
    "item_id": "004_oiran_5_backwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "004_oiran_5_backwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "004_oiran/01_color_A/02_tier_2/05_backwear.png",
    "animated": false
  },
  {
    "id": "004_oiran_5_backwear_a_tier_3",
    "item_id": "004_oiran_5_backwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "004_oiran/01_color_A/03_tier_3/05_backwear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_1_headwear_a_tier_1",
    "item_id": "005_ancient_egyptian_king_1_headwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "005_ancient_egyptian_king_1_headwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "005_ancient_egyptian_king/01_color_A/01_tier_1/01_headwear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_1_headwear_a_tier_2",
    "item_id": "005_ancient_egyptian_king_1_headwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "005_ancient_egyptian_king_1_headwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "005_ancient_egyptian_king/01_color_A/02_tier_2/01_headwear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_1_headwear_a_tier_3",
    "item_id": "005_ancient_egyptian_king_1_headwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "005_ancient_egyptian_king/01_color_A/03_tier_3/01_headwear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_2_eyewear_a_tier_1",
    "item_id": "005_ancient_egyptian_king_2_eyewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "005_ancient_egyptian_king_2_eyewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "005_ancient_egyptian_king/01_color_A/01_tier_1/02_eyewear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_2_eyewear_a_tier_2",
    "item_id": "005_ancient_egyptian_king_2_eyewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "005_ancient_egyptian_king_2_eyewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "005_ancient_egyptian_king/01_color_A/02_tier_2/02_eyewear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_2_eyewear_a_tier_3",
    "item_id": "005_ancient_egyptian_king_2_eyewear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "005_ancient_egyptian_king/01_color_A/03_tier_3/02_eyewear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_3_facewear_a_tier_1",
    "item_id": "005_ancient_egyptian_king_3_facewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "005_ancient_egyptian_king_3_facewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "005_ancient_egyptian_king/01_color_A/01_tier_1/03_facewear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_3_facewear_a_tier_2",
    "item_id": "005_ancient_egyptian_king_3_facewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "005_ancient_egyptian_king_3_facewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "005_ancient_egyptian_king/01_color_A/02_tier_2/03_facewear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_3_facewear_a_tier_3",
    "item_id": "005_ancient_egyptian_king_3_facewear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "005_ancient_egyptian_king/01_color_A/03_tier_3/03_facewear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_4_neckwear_a_tier_1",
    "item_id": "005_ancient_egyptian_king_4_neckwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "005_ancient_egyptian_king_4_neckwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "005_ancient_egyptian_king/01_color_A/01_tier_1/04_neckwear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_4_neckwear_a_tier_2",
    "item_id": "005_ancient_egyptian_king_4_neckwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "005_ancient_egyptian_king_4_neckwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "005_ancient_egyptian_king/01_color_A/02_tier_2/04_neckwear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_4_neckwear_a_tier_3",
    "item_id": "005_ancient_egyptian_king_4_neckwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "005_ancient_egyptian_king/01_color_A/03_tier_3/04_neckwear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_5_backwear_a_tier_1",
    "item_id": "005_ancient_egyptian_king_5_backwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "005_ancient_egyptian_king_5_backwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "005_ancient_egyptian_king/01_color_A/01_tier_1/05_backwear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_5_backwear_a_tier_2",
    "item_id": "005_ancient_egyptian_king_5_backwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "005_ancient_egyptian_king_5_backwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "005_ancient_egyptian_king/01_color_A/02_tier_2/05_backwear.png",
    "animated": false
  },
  {
    "id": "005_ancient_egyptian_king_5_backwear_a_tier_3",
    "item_id": "005_ancient_egyptian_king_5_backwear_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "005_ancient_egyptian_king/01_color_A/03_tier_3/05_backwear.png",
    "animated": false
  },
  {
    "id": "006_angel_1_headwear_a_tier_1",
    "item_id": "006_angel_1_headwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_1_headwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "006_angel/01_color_A/01_tier_1/01_headwear.png",
    "animated": false
  },
  {
    "id": "006_angel_1_headwear_a_tier_2",
    "item_id": "006_angel_1_headwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_1_headwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "006_angel/01_color_A/02_tier_2/01_headwear.png",
    "animated": false
  },
  {
    "id": "006_angel_1_headwear_a_tier_3",
    "item_id": "006_angel_1_headwear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_1_headwear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "006_angel/01_color_A/03_tier_3/01_headwear.png",
    "animated": false
  },
  {
    "id": "006_angel_1_headwear_a_tier_4",
    "item_id": "006_angel_1_headwear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "006_angel/01_color_A/04_tier_4/01_headwear.png",
    "animated": false
  },
  {
    "id": "006_angel_2_eyewear_a_tier_1",
    "item_id": "006_angel_2_eyewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_2_eyewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "006_angel/01_color_A/01_tier_1/02_eyewear.png",
    "animated": false
  },
  {
    "id": "006_angel_2_eyewear_a_tier_2",
    "item_id": "006_angel_2_eyewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_2_eyewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "006_angel/01_color_A/02_tier_2/02_eyewear.png",
    "animated": false
  },
  {
    "id": "006_angel_2_eyewear_a_tier_3",
    "item_id": "006_angel_2_eyewear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_2_eyewear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "006_angel/01_color_A/03_tier_3/02_eyewear.png",
    "animated": false
  },
  {
    "id": "006_angel_2_eyewear_a_tier_4",
    "item_id": "006_angel_2_eyewear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "006_angel/01_color_A/04_tier_4/02_eyewear.png",
    "animated": false
  },
  {
    "id": "006_angel_3_facewear_a_tier_1",
    "item_id": "006_angel_3_facewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_3_facewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "006_angel/01_color_A/01_tier_1/03_facewear.png",
    "animated": false
  },
  {
    "id": "006_angel_3_facewear_a_tier_2",
    "item_id": "006_angel_3_facewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_3_facewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "006_angel/01_color_A/02_tier_2/03_facewear.png",
    "animated": false
  },
  {
    "id": "006_angel_3_facewear_a_tier_3",
    "item_id": "006_angel_3_facewear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_3_facewear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "006_angel/01_color_A/03_tier_3/03_facewear.png",
    "animated": false
  },
  {
    "id": "006_angel_3_facewear_a_tier_4",
    "item_id": "006_angel_3_facewear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "006_angel/01_color_A/04_tier_4/03_facewear.png",
    "animated": false
  },
  {
    "id": "006_angel_4_neckwear_a_tier_1",
    "item_id": "006_angel_4_neckwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_4_neckwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "006_angel/01_color_A/01_tier_1/04_neckwear.png",
    "animated": false
  },
  {
    "id": "006_angel_4_neckwear_a_tier_2",
    "item_id": "006_angel_4_neckwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_4_neckwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "006_angel/01_color_A/02_tier_2/04_neckwear.png",
    "animated": false
  },
  {
    "id": "006_angel_4_neckwear_a_tier_3",
    "item_id": "006_angel_4_neckwear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_4_neckwear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "006_angel/01_color_A/03_tier_3/04_neckwear.png",
    "animated": false
  },
  {
    "id": "006_angel_4_neckwear_a_tier_4",
    "item_id": "006_angel_4_neckwear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "006_angel/01_color_A/04_tier_4/04_neckwear.png",
    "animated": false
  },
  {
    "id": "006_angel_5_backwear_a_tier_1",
    "item_id": "006_angel_5_backwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_5_backwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "006_angel/01_color_A/01_tier_1/05_backwear.png",
    "animated": false
  },
  {
    "id": "006_angel_5_backwear_a_tier_2",
    "item_id": "006_angel_5_backwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_5_backwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "006_angel/01_color_A/02_tier_2/05_backwear.png",
    "animated": false
  },
  {
    "id": "006_angel_5_backwear_a_tier_3",
    "item_id": "006_angel_5_backwear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "006_angel_5_backwear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "006_angel/01_color_A/03_tier_3/05_backwear.png",
    "animated": false
  },
  {
    "id": "006_angel_5_backwear_a_tier_4",
    "item_id": "006_angel_5_backwear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "006_angel/01_color_A/04_tier_4/05_backwear.png",
    "animated": false
  },
  {
    "id": "007_devil_1_headwear_a_tier_1",
    "item_id": "007_devil_1_headwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_1_headwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "007_devil/01_color_A/01_tier_1/01_headwear.png",
    "animated": false
  },
  {
    "id": "007_devil_1_headwear_a_tier_2",
    "item_id": "007_devil_1_headwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_1_headwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "007_devil/01_color_A/02_tier_2/01_headwear.png",
    "animated": false
  },
  {
    "id": "007_devil_1_headwear_a_tier_3",
    "item_id": "007_devil_1_headwear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_1_headwear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "007_devil/01_color_A/03_tier_3/01_headwear.png",
    "animated": false
  },
  {
    "id": "007_devil_1_headwear_a_tier_4",
    "item_id": "007_devil_1_headwear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "007_devil/01_color_A/04_tier_4/01_headwear.png",
    "animated": false
  },
  {
    "id": "007_devil_2_eyewear_a_tier_1",
    "item_id": "007_devil_2_eyewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_2_eyewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "007_devil/01_color_A/01_tier_1/02_eyewear.png",
    "animated": false
  },
  {
    "id": "007_devil_2_eyewear_a_tier_2",
    "item_id": "007_devil_2_eyewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_2_eyewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "007_devil/01_color_A/02_tier_2/02_eyewear.png",
    "animated": false
  },
  {
    "id": "007_devil_2_eyewear_a_tier_3",
    "item_id": "007_devil_2_eyewear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_2_eyewear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "007_devil/01_color_A/03_tier_3/02_eyewear.png",
    "animated": false
  },
  {
    "id": "007_devil_2_eyewear_a_tier_4",
    "item_id": "007_devil_2_eyewear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "007_devil/01_color_A/04_tier_4/02_eyewear.png",
    "animated": false
  },
  {
    "id": "007_devil_3_facewear_a_tier_1",
    "item_id": "007_devil_3_facewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_3_facewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "007_devil/01_color_A/01_tier_1/03_facewear.png",
    "animated": false
  },
  {
    "id": "007_devil_3_facewear_a_tier_2",
    "item_id": "007_devil_3_facewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_3_facewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "007_devil/01_color_A/02_tier_2/03_facewear.png",
    "animated": false
  },
  {
    "id": "007_devil_3_facewear_a_tier_3",
    "item_id": "007_devil_3_facewear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_3_facewear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "007_devil/01_color_A/03_tier_3/03_facewear.png",
    "animated": false
  },
  {
    "id": "007_devil_3_facewear_a_tier_4",
    "item_id": "007_devil_3_facewear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "007_devil/01_color_A/04_tier_4/03_facewear.png",
    "animated": false
  },
  {
    "id": "007_devil_4_neckwear_a_tier_1",
    "item_id": "007_devil_4_neckwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_4_neckwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "007_devil/01_color_A/01_tier_1/04_neckwear.png",
    "animated": false
  },
  {
    "id": "007_devil_4_neckwear_a_tier_2",
    "item_id": "007_devil_4_neckwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_4_neckwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "007_devil/01_color_A/02_tier_2/04_neckwear.png",
    "animated": false
  },
  {
    "id": "007_devil_4_neckwear_a_tier_3",
    "item_id": "007_devil_4_neckwear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_4_neckwear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "007_devil/01_color_A/03_tier_3/04_neckwear.png",
    "animated": false
  },
  {
    "id": "007_devil_4_neckwear_a_tier_4",
    "item_id": "007_devil_4_neckwear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "007_devil/01_color_A/04_tier_4/04_neckwear.png",
    "animated": false
  },
  {
    "id": "007_devil_5_backwear_a_tier_1",
    "item_id": "007_devil_5_backwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_5_backwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "007_devil/01_color_A/01_tier_1/05_backwear.png",
    "animated": false
  },
  {
    "id": "007_devil_5_backwear_a_tier_2",
    "item_id": "007_devil_5_backwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_5_backwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "007_devil/01_color_A/02_tier_2/05_backwear.png",
    "animated": false
  },
  {
    "id": "007_devil_5_backwear_a_tier_3",
    "item_id": "007_devil_5_backwear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "007_devil_5_backwear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "007_devil/01_color_A/03_tier_3/05_backwear.png",
    "animated": false
  },
  {
    "id": "007_devil_5_backwear_a_tier_4",
    "item_id": "007_devil_5_backwear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "007_devil/01_color_A/04_tier_4/05_backwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_1_headwear_a_tier_1",
    "item_id": "008_whiteday_1_headwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_1_headwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "008_whiteday/01_color_A/01_tier_1/01_headwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_1_headwear_a_tier_2",
    "item_id": "008_whiteday_1_headwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_1_headwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "008_whiteday/01_color_A/02_tier_2/01_headwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_1_headwear_a_tier_3",
    "item_id": "008_whiteday_1_headwear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_1_headwear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "008_whiteday/01_color_A/03_tier_3/01_headwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_1_headwear_a_tier_4",
    "item_id": "008_whiteday_1_headwear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "008_whiteday/01_color_A/04_tier_4/01_headwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_2_eyewear_a_tier_1",
    "item_id": "008_whiteday_2_eyewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_2_eyewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "008_whiteday/01_color_A/01_tier_1/02_eyewear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_2_eyewear_a_tier_2",
    "item_id": "008_whiteday_2_eyewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_2_eyewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "008_whiteday/01_color_A/02_tier_2/02_eyewear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_2_eyewear_a_tier_3",
    "item_id": "008_whiteday_2_eyewear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_2_eyewear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "008_whiteday/01_color_A/03_tier_3/02_eyewear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_2_eyewear_a_tier_4",
    "item_id": "008_whiteday_2_eyewear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "008_whiteday/01_color_A/04_tier_4/02_eyewear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_3_facewear_a_tier_1",
    "item_id": "008_whiteday_3_facewear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_3_facewear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "008_whiteday/01_color_A/01_tier_1/03_facewear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_3_facewear_a_tier_2",
    "item_id": "008_whiteday_3_facewear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_3_facewear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "008_whiteday/01_color_A/02_tier_2/03_facewear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_3_facewear_a_tier_3",
    "item_id": "008_whiteday_3_facewear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_3_facewear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "008_whiteday/01_color_A/03_tier_3/03_facewear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_3_facewear_a_tier_4",
    "item_id": "008_whiteday_3_facewear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "008_whiteday/01_color_A/04_tier_4/03_facewear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_4_neckwear_a_tier_1",
    "item_id": "008_whiteday_4_neckwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_4_neckwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "008_whiteday/01_color_A/01_tier_1/04_neckwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_4_neckwear_a_tier_2",
    "item_id": "008_whiteday_4_neckwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_4_neckwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "008_whiteday/01_color_A/02_tier_2/04_neckwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_4_neckwear_a_tier_3",
    "item_id": "008_whiteday_4_neckwear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_4_neckwear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "008_whiteday/01_color_A/03_tier_3/04_neckwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_4_neckwear_a_tier_4",
    "item_id": "008_whiteday_4_neckwear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "008_whiteday/01_color_A/04_tier_4/04_neckwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_5_backwear_a_tier_1",
    "item_id": "008_whiteday_5_backwear_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_5_backwear_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "008_whiteday/01_color_A/01_tier_1/05_backwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_5_backwear_a_tier_2",
    "item_id": "008_whiteday_5_backwear_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_5_backwear_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "008_whiteday/01_color_A/02_tier_2/05_backwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_5_backwear_a_tier_3",
    "item_id": "008_whiteday_5_backwear_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "008_whiteday_5_backwear_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "008_whiteday/01_color_A/03_tier_3/05_backwear.png",
    "animated": false
  },
  {
    "id": "008_whiteday_5_backwear_a_tier_4",
    "item_id": "008_whiteday_5_backwear_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "008_whiteday/01_color_A/04_tier_4/05_backwear.png",
    "animated": false
  }
]
